<template>
	<div>
		<h2 class="text-lg-h5 font-weight-bold mb-4">Verwaltung Video</h2>
		<transition name="fade" mode="out-in">
			<div v-if="$store.state.display.loadingPublisher"
					 class="d-flex flex-column align-center justify-center"
					 style="min-height:60vh" :key="0">
				<v-progress-circular :size="80" :width="3" :color="ada.pink"
														 indeterminate
				></v-progress-circular>
				<div class="mt-6" :style="{fontSize: '1.2em', color: ada.darkGrey}">Inhalte werden geladen ...</div>
			</div>
			<div v-else :key="1">
				<v-img
					v-if="videoConfig && !$store.state.video.loading.config && videoConfig.Site.UsesAdaBundle === 1"
					class="adaBundle"
					src="../assets/adabundle_stamp.png"></v-img>
				<PublisherSelect store="video"></PublisherSelect>
				<div style="max-width: 500px">
					<SiteSelect v-model="selectedSite" :hide-add="true" store="video" type="video">
						<TooltipIcon
							v-if="!$vuetify.breakpoint.smAndDown"
							:custom-style="{marginLeft:'10px'}"
							:color="ada.darkGrey"
							:fab="true"
							:xsmall="true" @click="showSitesList = !showSitesList"
							:tooltip="'Seitenliste '+ (showSitesList ? 'ausblenden' : 'einblenden')">
							mdi-format-list-bulleted
						</TooltipIcon>
					</SiteSelect>
				</div>
				<SiteStatus @intervalStart="siteStatusInterval = $event" store="video" class="pb-1"
										:currentIntervalId="siteStatusInterval"
										:startIntervalEvent="startSiteInterval"></SiteStatus>
				<v-row>
					<v-col :cols="showSitesList ? 3 : 0" v-if="!$vuetify.breakpoint.smAndDown">
						<SitesList v-model="selectedSite" :show="showSitesList" store="video" type="video"
											 :style="{'height': contentHeight + 'px'}"></SitesList>
					</v-col>
					<v-col :cols="showSitesList ? 9 : 12">
						<v-tabs class="borderTopRadius" v-model="tab" :color="ada.blue" show-arrows
										:key="showSitesList">
							<v-tabs-slider :color="ada.blue"></v-tabs-slider>
							<v-tab flat v-for="tab in tabs" :key="tab.name">
								<span>{{ tab.name }}</span>
							</v-tab>
						</v-tabs>
						<v-tabs-items v-model="tab" ref="tabContent" class="borderBottomRadius">
							<v-tab-item>
								<v-card flat :style="{height:contentHeight-48+'px'}">
									<v-card-text style="height:100%;">
										<transition name="fade" mode="out-in">
											<div v-if="configLoading"
													 class="d-flex justify-center align-center" style="height:100%;">
												<v-progress-circular :size="50" :width="3"
																						 :color="ada.pink"
																						 indeterminate
												></v-progress-circular>
											</div>
											<div v-else style="height:100%;">
												<!--  C O N F I G   T A B  -->
												<div v-if="data" class="d-flex flex-column justify-space-between px-2"
														 style="height:100%;">
													<v-row>
														<v-col cols="12" lg="5" class="pr-12">
															<div>
																<Input v-model="data.MetatronId" label="Metatron ID"
																			 :disabled="readOnly"
																			 :hide-details="true"
																			 style="max-width: 200px"
																			 @input="checkChanges"></Input>
															</div>
															<Toggle v-model="data.Consent" label="Consent"
																			:hide-details="true"
																			@input="checkChanges" :disabled="readOnly"></Toggle>
															<Toggle v-model="data.IsMediaImpact" :hide-details="true"
																			@input="checkChanges" :disabled="readOnly">
																<div class="mr-2">Media Impact</div>
																<TooltipIcon :color="ada.darkGrey"
																						 tooltip="Eingeschränktes Targeting für Media Impact Seiten">
																	mdi-information
																</TooltipIcon>
															</Toggle>
															<Toggle v-model="data.IsSingleSpotAllowed"
																			@input="checkChanges"
																			:disabled="readOnly" :hide-details="true">
																<div class="mr-2">Single Spot aktiv</div>
																<TooltipIcon :color="ada.darkGrey"
																						 tooltip="Auf dieser Seite immer Single Spot">
																	mdi-information
																</TooltipIcon>
															</Toggle>
															<Toggle v-model="data.LoadConfig" @input="checkChanges"
																			:disabled="readOnly" :hide-details="true">
																<div class="mr-2">Nicht auf Config warten</div>
															</Toggle>
															<Toggle v-model="data.OptOutOnKidSecure"
																			@input="checkChanges"
																			:disabled="readOnly" :hide-details="true">
																<div class="mr-2">Optout on KidSecure</div>
																<TooltipIcon :color="ada.darkGrey"
																						 tooltip="Profilierung sowie Werbeausspielung für einzelne Unterseiten omplett unterbinden (Ticket OAC-219)">
																	mdi-information
																</TooltipIcon>
															</Toggle>
															<Toggle v-model="data.WaitForKidSecure"
																			@input="checkChanges"
																			:disabled="readOnly" :hide-details="true">
																<div class="mr-2">Auf KidSecure Signal warten</div>
															</Toggle>
														</v-col>
														<v-col cols="12" lg="7" class="pl-10"
																	 style="position: relative; color: #7c7c7e;">
															<v-row>
																<v-col>
																	<Toggle v-model="data.ApiFrameworksEnabled"
																					@input="checkChanges"
																					:disabled="readOnly" :hide-details="true">
																		<div class="mr-2">APIFrameworks aktivieren?
																		</div>
																	</Toggle>
																	<v-slide-y-transition hide-on-leave>
																		<Input v-if="data.ApiFrameworksEnabled"
																					 v-model="data.ApiFrameworksIDs"
																					 label="ApiFrameworks IDs"
																					 class="mt-3"
																					 :disabled="readOnly"
																					 :hide-details="true"
																					 style="max-width: 200px"
																					 @input="checkChanges"></Input>
																	</v-slide-y-transition>

																	<Toggle v-model="sellerIDEnabled"
																					:trueValue="true"
																					:falseValue="false"
																					@input="checkChanges"
																					:disabled="readOnly" :hide-details="true">
																		<div class="mr-2">SellerID aktivieren?
																		</div>
																	</Toggle>
																	<v-slide-y-transition hide-on-leave>
																		<Input v-if="sellerIDEnabled"
																					 v-model="data.SellerID"
																					 label="Seller ID"
																					 :disabled="readOnly"
																					 :hide-details="true"
																					 class="mb-4 mt-4"
																					 style="max-width: 200px"
																					 @input="checkChanges"></Input>
																	</v-slide-y-transition>
																</v-col>
															</v-row>

															<div class="divider"></div>
															<v-row class="mb-1 mt-5 font-weight-bold" no-gutters>
																<v-col>
																	<div style="color:#90A4AE">Speicherorte</div>
																</v-col>
															</v-row>

															<!--  P R E V I E W   P A T H S  -->
															<v-row no-gutters
																		 v-for="(path, i) in $store.state.display.relPaths"
																		 :key="'preview_'+path" class="pathRowWrapper">
																<v-col cols="12" class="location_row">
																	<div style="width: 80px;">
																		{{ i === 0 ? 'Preview:' : '' }}
																	</div>
																	<div class="col2">
																		https://adctrl.emsmobile.de/molten/preview/{{
																			selectedSite.Name
																		}}/{{
																			path
																		}}
																	</div>
																</v-col>
															</v-row>

															<!--  L I V E   P A T H S  -->
															<div class="mt-4">
																<v-row no-gutters
																			 v-for="(path, i) in $store.state.display.relPaths"
																			 :key="'live_'+path" class="pathRowWrapper">
																	<v-col cols="12" class="location_row">
																		<div
																			:style="{width: $vuetify.breakpoint.lgAndUp ? '50px' : '80px'}">
																			{{ i === 0 ? 'Live:' : '' }}
																		</div>
																		<div class="col2">
																			https://adctrl.emsmobile.de/molten/live/{{
																				selectedSite.Name
																			}}/{{ path }}
																		</div>
																	</v-col>
																</v-row>
															</div>
														</v-col>
													</v-row>

													<div v-if="!readOnly" class="d-flex flex-row">
														<TooltipButton
															tooltip="Änderungen speichern & Preview Deployment"
															:color="ada.blue" icon="mdi-content-save"
															:loading="$store.state.video.loading.submit"
															style="width:fit-content"
															@click="submit(false)"
														>Speichern & Preview
														</TooltipButton>
														<Button icon="mdi-upload" @click="showDeployDialog = true"
																		style="width:fit-content"
																		class="ml-4"
																		:loading="$store.state.video.loading.deploy"
																		:color="ada.pink"> Deploy
														</Button>
													</div>
												</div>
												<div v-else class="noSiteSelected">
													Bitte eine Seite zum Bearbeiten auswählen.
												</div>
											</div>
										</transition>
									</v-card-text>
								</v-card>
							</v-tab-item>
							<v-tab-item>
								<v-card flat :style="{height:contentHeight-48+'px', overflow: 'auto'}">
									<v-card-text style="height: 100%">
										<transition name="fade" mode="out-in">
											<div v-if="videoConfig">
												<Datatable title="Deployments"
																	 :loading="$store.state.video.loading.config"
																	 :items="videoConfig ? historyItems : []"
																	 :headers="headers"
																	 sortBy="created_at"
																	 :sortDesc="true"></Datatable>
											</div>
											<div v-else class="noSiteSelected">
												Bitte eine Seite zum Bearbeiten auswählen.
											</div>
										</transition>
									</v-card-text>
								</v-card>
							</v-tab-item>
						</v-tabs-items>
					</v-col>
				</v-row>
			</div>
		</transition>
		<SaveChangesDialog v-model="showSaveChangesDialog" @save="submit(true)"
											 @discard="discard"></SaveChangesDialog>
		<Dialog v-model="showDeployDialog" title="Deploy" ok-text="Deploy" :loading="$store.state.video.loading.deploy"
						@ok="deploy" @cancel="showDeployDialog = false">
			<p>Bitte gebe eine Deploy Message ein. Diese wird später in der History angezeigt.</p>
			<Textarea v-model="message" label="Deploy message" rows="3"></Textarea>
		</Dialog>
	</div>
</template>

<script>
import ada from '@/scss/ada_colors.scss'
import PublisherSelect from "./components/PublisherSelect";
import SiteSelect from "./components/SiteSelect";
import TooltipIcon from "../components/TooltipIcon";
import SitesList from "./components/SitesList";
import Toggle from "../components/buttons/Toggle";
import SaveChangesDialog from "./components/SaveChangesDialog";
import Button from "../components/buttons/Button";
import Dialog from "../components/Dialog";
import Textarea from "../components/Inputs/Textarea";
import Datatable from "../components/Tables/Datatable";
import TooltipButton from "../components/buttons/TooltipButton";
import Input from "../components/Inputs/Input";
import SiteStatus from "./components/SiteStatus";
import Utils from "../scripts/Utils";

export default {
	name: "Video",
	components: {
		SiteStatus,
		Input,
		TooltipButton,
		Datatable,
		Textarea,
		Dialog, Button, SaveChangesDialog, Toggle, SitesList, TooltipIcon, SiteSelect, PublisherSelect
	},
	data: () => ({
		ada,
		selectedSite: null,
		showSitesList: true,
		showSaveChangesDialog: false,
		showDeployDialog: false,
		sellerIDEnabled: false,
		tab: 0,
		tabs: [
			{name: 'Konfiguration'},
			{name: 'History'},
		],
		headers: [
			{text: 'Message', value: 'deploy_message', sortable: false},
			{text: 'Datum', value: 'created_at', width: '200px'},
		],
		data: null,
		hasChanges: false,
		message: null,
		siteStatusInterval: null,
		startSiteInterval: 0,
	}),
	created() {
		window.addEventListener('beforeunload', this.clearSiteStatusInterval)
	},
	mounted() {
		if (this.vuexState.videoConfig) {
			this.selectedSite = this.videoConfig.Site;
			this.startSiteInterval++;
		}
		this.$root.$on('inactive', this.clearSiteStatusInterval);
	},
	beforeDestroy() {
		this.$root.$off('inactive', this.clearSiteStatusInterval);
		window.removeEventListener('beforeunload', this.clearSiteStatusInterval);
	},
	beforeRouteLeave(to, from, next) {
		clearInterval(this.siteStatusInterval);
		this.siteStatusInterval = null;
		next();
	},
	computed: {
		vuexState() {
			return this.$store.state.video;
		},
		videoConfig() {
			return this.vuexState.videoConfig;
		},
		historyItems() {
			let ret = JSON.parse(JSON.stringify(this.videoConfig.VideoHistory));
			for (let i = 0; i < ret.length; i++) {
				ret[i].created_at = Utils.formatDate(ret[i].updated, true);
			}
			return ret;
		},
		configLoading() {
			return this.vuexState.loading.config;
		},

		contentHeight() {
			return 550; //this.data && this.data.ApiFrameworksEnabled ? 610 : 550
		},
		role() {
			return this.$store.state.users.role
		},
		readOnly() {
			return (this.role !== 'video' && this.role !== "admin") || this.$store.state.readOnly === 1
		}
	}
	,
	methods: {
		fetchVideo() {
			this.fetchSiteStatus();
			if (this.selectedSite && this.selectedSite.SiteId) {
				this.$store.dispatch('video/fetchVideo', this.selectedSite.SiteId);
			}
		},
		async submit(fromSaveChangesDialog = false) {
			let json = {
				consent: this.data.Consent,
				mediaImpact: this.data.IsMediaImpact,
				singleSpot: this.data.IsSingleSpotAllowed,
				site_id: fromSaveChangesDialog ? this.vuexState.previousSiteId : this.selectedSite.SiteId,
				metatronId: this.data.MetatronId,
				loadConfig: this.data.LoadConfig || 0,
				optOutOnKidSecure: this.data.OptOutOnKidSecure,
				waitForKidSecure: this.data.WaitForKidSecure,
				apiFrameworksEnabled: this.data.ApiFrameworksEnabled,
				apiFrameworksIDs: this.data.ApiFrameworksIDs,
				sellerID: this.sellerIDEnabled ? this.data.SellerID : 0,
			}
			let data = await this.$store.dispatch('video/editVideo', {
				previousSiteId: fromSaveChangesDialog,
				data: json
			});

			if (data.Status) {
				this.hasChanges = false;
				if (fromSaveChangesDialog) this.fetchVideo();
				this.$root.$emit('snackbar', "Erfolgreich gespeichert.");
			} else {
				this.$root.$emit('snackbar', "Speichern fehlgeschlagen.", 'error');
			}
			if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
		},
		async deploy() {
			let json = {
				message: this.message,
				site_id: this.selectedSite.SiteId
			}
			let data = await this.$store.dispatch('video/deployVideo', json);
			if (data.Status) {
				this.showDeployDialog = false;
				this.message = null;
				this.$root.$emit('snackbar', "Erfolgreich deployed.");
			} else {
				this.$root.$emit('snackbar', "Deploy fehlgeschlagen.", 'error');
			}
			if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
		},
		async fetchSiteStatus() {
			if (this.selectedSite && this.$store.state.users.role !== "read") {
				await this.$store.dispatch('display/siteStatus', {
					siteId: this.selectedSite.SiteId,
					type: 'video'
				});
			}
		},
		checkChanges() {
			let og_data = this.$store.state.video.videoConfig.Video;
			this.hasChanges = (og_data.KidSecure !== this.data.KidSecure ||
				og_data.Consent !== this.data.Consent ||
				og_data.IsMediaImpact !== this.data.IsMediaImpact ||
				og_data.IsSingleSpotAllowed !== this.data.IsSingleSpotAllowed ||
				og_data.MetatronId !== this.data.MetatronId ||
				og_data.LoadConfig !== this.data.LoadConfig ||
				og_data.OptOutOnKidSecure !== this.data.OptOutOnKidSecure ||
				og_data.WaitForKidSecure !== this.data.WaitForKidSecure ||
				og_data.ApiFrameworksEnabled !== this.data.ApiFrameworksEnabled ||
				og_data.ApiFrameworksIDs !== this.data.ApiFrameworksIDs ||
				og_data.SellerID !== this.data.SellerID
			);
		},
		clearSiteStatusInterval() {
			if (this.siteStatusInterval) {
				clearInterval(this.siteStatusInterval);
			}
		},
		discard() {
			this.hasChanges = false;
			this.fetchVideo();
		}
	},
	watch: {
		selectedSite(newValue) {
			this.$store.commit('video/updateActiveSiteId', newValue ? newValue.SiteId : null);
			this.$store.commit('video/setSelectedSite', newValue);
			if (this.hasChanges && this.$store.state.readOnly === 0) {
				this.showSaveChangesDialog = true;
			} else {
				if (newValue) {
					this.fetchVideo();
				} else {
					this.$store.commit('video/setVideo', null)
				}
			}
		},
		videoConfig(newValue) {
			this.data = JSON.parse(JSON.stringify(newValue.Video));
			this.sellerIDEnabled = newValue.Video.SellerID !== null && newValue.Video.SellerID !== "null" && newValue.Video.SellerID !== "" && newValue.Video.SellerID !== '0';
		},
		siteStatusInterval(n, o) {
			if (o && n !== o) {
				clearInterval(o);
			}
		}
	},
}
</script>

<style scoped>

.noSiteSelected {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	font-size: 1.3em;
	min-height: 30vh;
}


.adaBundle {
	position: absolute;
	right: 4rem;
	width: 210px;
	height: 205px;
	top: 5rem;
	z-index: 1;
	object-fit: contain;
	-webkit-animation-name: pulse;
	animation-name: pulse;
	-webkit-animation-duration: 0.5s;
	animation-duration: 0.5s;
	opacity: 0;
	-webkit-animation-fill-mode: forwards;
	animation-fill-mode: forwards;
}

@-webkit-keyframes pulse {
	0% {
		opacity: 0;
	}
	10% {
		opacity: .50;
		transform-origin: 50% 50%;
		transform: rotate(-2deg) scale(5);
		transition: all .3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
	}
	100% {
		opacity: 1;
		transform: rotate(15deg) scale(1);
	}
}

.divider {
	position: absolute;
	border-right: 1px solid rgba(0, 0, 0, 0.12);
	left: 0;
	height: 60%;
	top: 10%;
	margin-right: 10px;
	margin-left: 10px;
}

.pathRowWrapper {
	font-size: 0.8rem;
	color: #90A4AE;
}
</style>